import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容导航",
    links: [
      { label: "首页", to: "/" },
      { label: "伦理电影", to: "/movies" },
      { label: "伦理电视剧", to: "/series" },
      { label: "影评专题", to: "/reviews" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系我们", to: "/contact" },
      { label: "全站搜索", to: "/search" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-10 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">伦理视频</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              伦理视频是一个专注于伦理题材影视作品的内容门户。我们以剧情介绍、角色分析与影评解读三个维度，记录那些关于选择、代价与和解的故事，帮助观众在观看之外获得更完整的理解。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-background-300">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                contact@lunli-video.com
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                每周三更新影评专题
              </span>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title} className="md:col-span-2">
              <h4 className="font-label text-sm font-medium text-background-50">{column.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-label text-sm font-medium text-background-50">内容说明</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              本站所有影视作品的剧情、角色与影评均为演示内容，用于展示网站结构与阅读体验。站内不提供视频播放与下载服务。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 - 2026 伦理视频 Ethics Cinema. 保留所有权利。</p>
          <p className="flex items-center gap-4">
            <span>内容仅供学习与交流</span>
            <span className="hidden sm:inline text-background-50/20">|</span>
            <span>演示站点 · 无用户系统</span>
          </p>
        </div>
      </div>
    </footer>
  );
}